import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

import {
  HomeUpdatedArrowIcon,
  HomeUpdatedNextIcon,
  HomeUpdatedPrevIcon,
} from "../../../app-constants";

function Partner(props) {
  return (
    <section className="tekrevol__partner overflow-x-hidden p-100">
      <Container>
        <Row className="align-items-center">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="mt-auto mb-auto">
            <div className="example example-bottom" data-text="Strategy">
              <h2>
                Cultivating Strategic Partnerships for Business Growth{" "}
                <br className="d-xl-block d-none" />
              </h2>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="mt-auto mb-auto">
            <Row className="justify-content-center">
              <Col
                xs={6}
                sm={3}
                md={6}
                lg={4}
                xl={4}
                xxl={4}
                className="part-wrap mt-auto"
              >
                <div className="image">
                  <div className="link">
                    <StaticImage
                      src="../../images/home-update/partnership/microsoft.webp"
                      alt="Microsoft"
                      className="img-fluid"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["auto"]}
                      width={226}
                      height={226}
                    />
                  </div>
                </div>
                <div className="image">
                  <div className="link">
                    <StaticImage
                      src="../../images/home-update/partnership/google.webp"
                      alt="Google"
                      className="img-fluid"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["auto"]}
                      width={226}
                      height={226}
                    />
                  </div>
                </div>
              </Col>
              <Col
                xs={6}
                sm={3}
                md={6}
                lg={4}
                xl={4}
                xxl={4}
                className="part-wrap mt-auto"
              >
                <div className="image">
                  <div className="link">
                    <StaticImage
                      src="../../images/home-update/partnership/adobe.webp"
                      alt="Adobe"
                      className="img-fluid"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["auto"]}
                      width={226}
                      height={226}
                    />
                  </div>
                </div>
                <div className="image">
                  <div className="link">
                    <StaticImage
                      src="../../images/home-update/partnership/amazon.webp"
                      alt="Amazon"
                      className="img-fluid"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["auto"]}
                      width={226}
                      height={226}
                    />
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Partner;
